<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <div class="text-center">
        <div class="row">
          <!-- <div class="h3">即時影像(地圖)</div> -->
        </div>
        <!-- <div class="mobile-div" style="height: calc(100vh - 140px);"> -->
        <div class="mobile-div">
          <iframe :src="iSurveillanceUrl" class="border h-100 w-100">
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import config from '../../config'

export default {
  name: "Home",
  data() {
    return {
      iSurveillanceUrl: config.iSurveillanceUrl()
    };
  },
  // components: { DialogModal },
  methods: {
    getTime: function () {
      return moment().subtract("-30", "s").format("YYYY/MM/DD HH:mm");
    },
    selectStreaming: function (item, dashboard) {
      this.$refs.streamingModal.openModal();
      this.selectItem = item;
      this.selectDashoard = dashboard;
    },
  },
};
</script>

<style lang="scss" scoped>

@media only screen and (max-width: 766px){
  .mobile-div{
    height: calc(100vh - 200px)
  }
}

@media only screen and (min-width: 766px){
  .mobile-div{
    height: calc(100vh - 140px)
  }
}

</style>